import * as React from 'react';
import { Input, Row, Col, Table, message } from 'antd';
import { MSGDISPLAYTIME } from '../common/constants';
import '../../css/ShareTest.scss';
// import ReactPhoneInput from 'react-phone-input-2';
import strings from '../../eyeguide-localization/test/string.test.share';
import Utils from '../common/utils';
interface IShareTestProps {
    sharedTests: any;
    notifyUsers: any;
    isOpen: any;
}

interface IShareTestsState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorfname:    boolean;
    errorlname:    boolean;
    errorphone:    boolean;
    erroremail:    boolean;
    errorreemail:   boolean;
    columnData: Array<any>;
    columns: Array<any>;
    count: number;
    fname: string;
    lname: string;
    email: string;
    reemail: string;
    phone: any;
    cntryCodes: any;
    phoneVal: any;
}

export default class ShareTests extends React.Component<IShareTestProps, IShareTestsState> {
    name: any;
    constructor(props: IShareTestProps ) {
        super(props);

        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorfname: false,
            errorlname: false,
            erroremail: false,
            errorreemail: false,
            errorphone: false,
            columnData: [],
            columns: [],
            count: 0,
            fname: '',
            lname: '',
            email: '',
            reemail: '',
            phone: '',
            cntryCodes: '',
            phoneVal: ''
            
        };
    }

    componentDidMount() {
        let columns = this.buildColumns();
        this.setState({
            columns: columns
        });
        this.resetControls();
        setTimeout(() => {this.name.focus() ; }, 1);
        // this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps: any) {
        // this.resetControls();
        if (nextProps.isOpen === false) {
            this.resetControls();
        }
        setTimeout(() => {this.name.focus() ; }, 1);
    }

    render() {
        return (
        <div className="ShareTest">
            <span> {this.props.sharedTests.length + ' ' + strings.lsShareTestInfoTxt} </span>
            <div>{strings.lsShareTestInfoTxt2}</div>
            <Row>
                <Col xs={1} sm={1} md={2} lg={8} xl={5} className="labelFrame firstLabel">
                    <Input 
                        ref={val => this.name = val}
                        className={this.state.errorfname ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        placeholder={strings.lsFNamePalceholderTxt} 
                        onChange={(val) => this.setState({fname: val.target.value})}
                        value={this.state.fname}
                    />
                </Col>
                <Col xs={1} sm={1} md={2} lg={8} xl={5} className="labelFrame">
                    <Input 
                        className={this.state.errorlname ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        placeholder={strings.lsLNamePalceholderTxt} 
                        onChange={(val) => this.setState({lname: val.target.value})}
                        value={this.state.lname}
                    />
                </Col>
                <Col xs={1} sm={1} md={2} lg={8} xl={5} className="labelFrame">
                    <Input 
                        className={this.state.erroremail ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        onChange={(val) => this.setState({email: val.target.value})}
                        placeholder={strings.lsEmailPalceholderTxt} 
                        value={this.state.email}
                    />
                </Col>
                {/* <Col xs={1} sm={1} md={2} lg={8} xl={5} className="labelFrame">
                    <Input 
                        className={this.state.errorreemail ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        onChange={(val) => this.setState({reemail: val.target.value})}
                        placeholder={strings.lsReEnterPalceholderEmailTxt} 
                        value={this.state.reemail}
                    />
                </Col> */}
                <Col xs={1} sm={1} md={2} lg={8} xl={5} className="labelFrame">
                    <Input 
                        className={this.state.errorphone ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                        onChange={(val) => this.setState({phone: val.target.value})}
                        placeholder={strings.lsPhonePalceholderTxt} 
                        value={this.state.phone}
                    />
                </Col>
                <Col xs={1} sm={1} md={2} lg={8} xl={1} className="labelFrame addLink">
                    <a 
                        onClick={ (e) => {    
                            // console.log('e in onlcick', record);  
                            e.stopPropagation();         
                            this.handleAdd();      
                            // this.props.notifyEditClick(record.organizationid); 
                        }
                        }
                    > {strings.lsAddTxt}
                    </a>
                </Col>
            </Row>            
            {/* <Card title="Users" bordered={false}> */}
            <div>
            <Table 
                columns={this.state.columns} 
                dataSource={this.state.columnData} 
                className="headers"
                pagination={false}
                rowKey={record => record.key}
                scroll={{ y: 150 }}
                locale={{ emptyText: '' }} 
            />
            </div>
            {/* </Card> */}

        </div>

        );
    }

    // private buildData(tests: Array<any>) {
    //     let columnData: Array<any> = [];
    //     tests.forEach( (element: any) => {
    //         let data = {
    //             name: element.name,
    //             email: element.email,
    //             phone: element.phone
    //         };
    //         columnData.push(data);
    //     }); 
    //     return columnData;
    // }
    
    private buildColumns() {
        let columns = [
            {
            title: strings.lsFNameTxt,
            dataIndex: 'fname',
            className: 'rows',
            width: 200,
          } ,
          {
            title: strings.lsLNameTxt,
            dataIndex: 'lname',
            className: 'rows',
            width: 200,
          } ,
          {
            title: strings.lsEmailTxt,
            dataIndex: 'email',
            className: 'rows',
            width: 200,
          },
          {
            title: 'Phone',
            dataIndex: 'phone',
            className: 'rows',
            width: 200,
          },
          {
            title: strings.lsActionTxt,
            dataIndex: 'testid',
            className: 'rows',
            render: (text: any, record: any) => (
                    <a 
                        onClick={ (e) => {    
                            console.log('e in onlcick', record);  
                            e.stopPropagation();     
                            this.onDelete(record.key);
                            // this.props.notifyShowProfileClick(record.playerid); 
                        }
                        }
                    >{strings.lsDeleteTxt}
                    </a>
            ),
          }
        ];
        return columns;
    }

    private handleAdd = () => {
        if (this.validateInput()) {
            const columnData = [...this.state.columnData];
            let count: number = this.state.count;
            const newData = {
                    key: this.state.count,
                    fname: this.state.fname,
                    lname: this.state.lname,
                    email: this.state.email,
                    phone: this.state.phone.trim(),
                    phoneVal: this.state.phoneVal
            };
            this.setState({
            columnData: [...columnData, newData],
            fname: '',
            lname: '',
            email: '',
            reemail: '',
            phone: '',
            phoneVal: '+1',
            count: count + 1
                          }, 
                          () => {
                            this.props.notifyUsers(this.state.columnData);
                        });
        }
    }

    private onDelete = (key) => {
        const dataSource = [...this.state.columnData];
        this.setState({ columnData: dataSource.filter(item => item.key !== key) }, 
                      () => this.props.notifyUsers(this.state.columnData));
    }

    /**
     * Reset all control values
     */
    private resetControls() {
        this.setState({
            fname: '',
            lname: '',
            email: '',
            reemail: '',
            phoneVal: '+1',
            phone: '',
            columnData: [],
            errorfname: false, 
            errorlname: false,
            erroremail: false,
            errorreemail: false, 
            errorphone: false
        });
    }

    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorfname: boolean = false;
        let errorlname: boolean = false;
        let erroremail: boolean = false;
        let errorreemail: boolean = false;
        let errorphone: boolean = false;
        this.state.fname !== null && this.state.fname.trim() === '' ? 
                    errorfname = true : errorfname = false;
        this.state.lname !== null && this.state.lname.trim() === '' ? 
                    errorlname = true : errorlname = false;
        this.state.email !== null && this.state.email.trim() === '' ? erroremail = true 
                    : erroremail = false;
        this.state.email !== null && this.state.email.trim() === '' ? erroremail = true 
                    : erroremail = false;
        // this.state.reemail !== null && this.state.reemail.trim() === '' ? errorreemail = true 
        //     : errorreemail = false;
        // if (this.state.email !== this.state.reemail) {
        //     erroremail = true;
        //     errorreemail = true;
        // } else {
        erroremail = erroremail ? erroremail : !Utils.validateEmail(this.state.email);
        // }
        this.state.phone && !Utils.validatePhone(this.state.phone) ?
                errorphone = true : errorphone = false;
        if (errorfname || errorlname || erroremail || errorreemail || errorphone) { isValid = false; }
        this.setState({errorfname, erroremail, errorlname, errorreemail, errorphone});

        let data = this.state.columnData;
        let isDuplicate =  isValid ? data.filter(d => {
            let phone = d.phone;
            let statephone = this.state.phone;
            return d.email === this.state.email ||
                (statephone && phone.replace(/\D/g, '') === statephone.replace(/\D/g, ''));
        }).length > 0 : false;
        console.log(' isDuplicate', isDuplicate);
        if (isValid && isDuplicate) {
            isValid = false;
            message.error(strings.lsUserInputError, MSGDISPLAYTIME);
        }
        return isValid;
    }

    // /**
    //  * sets the container element for dropdown menu
    //  */
    // private getContainer = (triggernode) => {
    //     return triggernode.parentNode;
    // }

    // private handleOnChange(value: string) {
    //     console.log('handleonchange', value);
    //     let formatValue = value.replace(/\D/g, '');
    //     console.log('formatValue', formatValue);
    //     this.setState({
    //         phone: formatValue,
    //         phoneVal: value
    //     });
    // }

    // private validateEmail(email: any) {
    //     // let re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    //     let re = /(\w+)\@(\w+)\.[a-zA-Z]/g;
    //     return re.test(email);
    // }
} 


// WEBPACK FOOTER //
// ./src/components/test/ShareTest.tsx